import React from 'react';
import { comparisonItems } from '../../data/mock';
import { Check, X } from 'lucide-react';

const ComparisonSection = () => {
  return (
    <section className="py-24 px-6 bg-[#0f0f0f]">
      <div className="max-w-5xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-sm font-medium text-white/50 uppercase tracking-wider mb-4 block">
            Our Approach
          </span>
          <h2 className="heading-2 text-white mb-4">Distribution, Not Growth Hacking</h2>
          <p className="body-medium text-[#737373] max-w-2xl mx-auto">
            We believe in sustainable, authentic growth. Here's what sets us apart.
          </p>
        </div>

        {/* Comparison Grid - Bento Style */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* What We Do */}
          <div className="rounded-3xl border border-white/20 bg-[#141414] p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-emerald-500 flex items-center justify-center">
                <Check size={20} className="text-white" strokeWidth={3} />
              </div>
              <h3 className="text-xl font-semibold text-white">What We Do</h3>
            </div>
            <ul className="space-y-4">
              {comparisonItems.whatWeDo.map((item, index) => (
                <li key={index} className="flex items-center gap-3">
                  <div className="w-5 h-5 rounded-full bg-emerald-500/20 flex items-center justify-center flex-shrink-0">
                    <Check size={12} className="text-emerald-400" strokeWidth={3} />
                  </div>
                  <span className="text-[#e5e5e5]">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* What We Don't Do */}
          <div className="rounded-3xl border border-white/10 bg-[#0a0a0a] p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                <X size={20} className="text-white/60" strokeWidth={3} />
              </div>
              <h3 className="text-xl font-semibold text-white">What We Don't Do</h3>
            </div>
            <ul className="space-y-4">
              {comparisonItems.whatWeDont.map((item, index) => (
                <li key={index} className="flex items-center gap-3">
                  <div className="w-5 h-5 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                    <X size={12} className="text-white/40" strokeWidth={3} />
                  </div>
                  <span className="text-[#737373]">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Trust Badge */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-white/5 border border-white/10">
            <div className="w-3 h-3 rounded-full bg-emerald-400 animate-pulse"></div>
            <span className="text-sm font-medium text-white/80">
              Safe & Sustainable — Your accounts stay protected with platform-safe posting limits
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
